export default __webpack_public_path__ + "static/media/1.92b0e92c.jpg";